import styled from 'styled-components';

export const Nav = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 26px;
`;

export const Badge = styled.div`
  position: absolute;
  top: 0;
  right: -10px;
`;
